// extracted by mini-css-extract-plugin
export default {"shadowed":"App_shadowed__BC3oN"};